<ion-card class="glass-card playlist-card">
  <ion-card-header>
    <div class="title-row">
      <ion-card-title>{{ playlist.targetTitle || playlist.sourceTitle || playlist.title }}</ion-card-title>
      <span class="status" [ngClass]="playlist.status.toLowerCase()">
        {{ playlist.status }}
        <ng-container *ngIf="playlist.status !== 'COMPLETED' && playlist.progress !== undefined">
          • {{ playlist.progress }}%
        </ng-container>
      </span>
    </div>
    <ion-card-subtitle>
      {{ playlist.sourceTitle || (playlist.sourcePlatform | titlecase) }}
      →
      {{ playlist.targetTitle || (playlist.targetPlatform | titlecase) }}
    </ion-card-subtitle>
  </ion-card-header>
  <ion-card-content>
    <div class="meta">
      <div>Tracks: {{ playlist.sourceTrackCount || playlist.trackCount || '—' }}</div>
      <div>Created: {{ playlist.createdAt | date: 'mediumDate' }}</div>
    </div>
    <div class="progress-row" *ngIf="playlist.status !== 'COMPLETED' && playlist.progress !== undefined">
      <ion-progress-bar [value]="playlist.progress / 100"></ion-progress-bar>
      <span class="progress-label">{{ playlist.progress }}%</span>
    </div>
    <div class="error" *ngIf="playlist.status === 'FAILED' && playlist.errorMessage">
      {{ playlist.errorMessage }}
    </div>
    <div class="actions">
      <ion-button *ngIf="playlist.sourcePlaylistUrl"
                  class="ghost-button"
                  [href]="playlist.sourcePlaylistUrl"
                  target="_blank"
                  rel="noopener"
                  [attr.aria-label]="'Abrir ' + platformLabel(playlist.sourcePlatform)">
        <ion-icon *ngIf="isSpotify(playlist.sourcePlatform)" src="/assets/icons/spotify.svg" class="platform-icon" aria-hidden="true"></ion-icon>
        <img
          *ngIf="isYoutube(playlist.sourcePlatform)"
          src="/assets/yt_icon_red_digital.png"
          class="platform-icon platform-icon--yt"
          alt="YouTube"
        />
        <!-- <span class="btn-label">Abrir {{ platformLabel(playlist.sourcePlatform) }}</span> -->
      </ion-button>
      <ion-button *ngIf="playlist.targetPlaylistUrl"
                  class="ghost-button"
                  [href]="playlist.targetPlaylistUrl"
                  target="_blank"
                  rel="noopener"
                  [attr.aria-label]="'Abrir ' + platformLabel(playlist.targetPlatform)">
        <ion-icon *ngIf="isSpotify(playlist.targetPlatform)" src="/assets/icons/spotify.svg" class="platform-icon" aria-hidden="true"></ion-icon>
        <img
          *ngIf="isYoutube(playlist.targetPlatform)"
          src="/assets/yt_icon_red_digital.png"
          class="platform-icon platform-icon--yt"
          alt="YouTube"
        />
        <!-- <span class="btn-label">Abrir {{ platformLabel(playlist.targetPlatform) }}</span> -->
      </ion-button>
      <!-- <ion-button fill="clear" color="danger" (click)="delete.emit(playlist.id)" aria-label="Eliminar playlist">
        <ion-icon slot="icon-only" name="trash"></ion-icon>
      </ion-button> -->
    </div>
  </ion-card-content>
</ion-card>
